"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.levels = exports.log = exports.withRequest = void 0;
const loglevel_1 = __importStar(require("loglevel"));
exports.log = loglevel_1.default;
Object.defineProperty(exports, "levels", { enumerable: true, get: function () { return loglevel_1.levels; } });
loglevel_1.default.setLevel(loglevel_1.default.levels.INFO);
// https://cloud.google.com/logging/docs/reference/v2/rest/v2/LogEntry#LogSeverity
var LogSeverity;
(function (LogSeverity) {
    LogSeverity[LogSeverity["DEFAULT"] = 0] = "DEFAULT";
    LogSeverity[LogSeverity["DEBUG"] = 100] = "DEBUG";
    LogSeverity[LogSeverity["INFO"] = 200] = "INFO";
    LogSeverity[LogSeverity["NOTICE"] = 300] = "NOTICE";
    LogSeverity[LogSeverity["WARNING"] = 400] = "WARNING";
    LogSeverity[LogSeverity["ERROR"] = 500] = "ERROR";
    LogSeverity[LogSeverity["CRITICAL"] = 600] = "CRITICAL";
    LogSeverity[LogSeverity["ALERT"] = 700] = "ALERT";
    LogSeverity[LogSeverity["EMERGENCY"] = 800] = "EMERGENCY";
})(LogSeverity || (LogSeverity = {}));
function format(severity, requestID, requestMethod, requestUrl, ...values) {
    const parts = values.map((value) => {
        const t = typeof value;
        return t === "object" ? JSON.stringify(value) : String(value);
    });
    // https://cloud.google.com/logging/docs/structured-logging
    const message = parts.join(" ");
    const httpRequest = {
        requestMethod,
        requestUrl,
    };
    const payload = {
        message,
        severity,
        httpRequest,
        "logging.googleapis.com/trace": requestID,
    };
    return JSON.stringify(payload);
}
function withRequest(requestID, method, url) {
    const delegate = loglevel_1.default;
    return {
        levels: delegate.levels,
        methodFactory: delegate.methodFactory,
        trace(...msg) {
            delegate.trace(format(LogSeverity.DEBUG, requestID, method, url, ...msg));
        },
        debug(...msg) {
            delegate.debug(format(LogSeverity.DEBUG, requestID, method, url, ...msg));
        },
        log(...msg) {
            delegate.log(format(LogSeverity.DEFAULT, requestID, method, url, ...msg));
        },
        info(...msg) {
            delegate.info(format(LogSeverity.INFO, requestID, method, url, ...msg));
        },
        warn(...msg) {
            delegate.warn(format(LogSeverity.WARNING, requestID, method, url, ...msg));
        },
        error(...msg) {
            delegate.error(format(LogSeverity.ERROR, requestID, method, url, ...msg));
        },
        setLevel(level, persist) {
            delegate.setLevel(level, persist);
        },
        getLevel() {
            return delegate.getLevel();
        },
        setDefaultLevel(level) {
            delegate.setDefaultLevel(level);
        },
        enableAll(persist) {
            delegate.enableAll(persist);
        },
        disableAll(persist) {
            delegate.disableAll(persist);
        },
        resetLevel() {
            delegate.resetLevel();
        },
    };
}
exports.withRequest = withRequest;
//# sourceMappingURL=log.js.map